const managingUnwantedCalls = {
  slug: 'managing-unwanted-calls',
  title: 'Managing unwanted calls on your mobile',
  description:
    'Practical strategies to reduce nuisance, telemarketing, and repeat scam calls on your phone in Australia.',
  category: 'guides',
  guideType: 'tips',
  readMinutes: 6,
  partnerTip: 'none',
  relatedSlugs: ['call-blocking-apps', 'telemarketing-laws-australia'],
  sections: [
    {
      type: 'heading',
      level: 2,
      text: 'Reduce how many get through',
    },
    {
      type: 'list',
      items: [
        'Register on the Do Not Call Register (Australia)',
        'Enable carrier scam filter if available',
        'Use “Silence unknown callers” on iPhone or Android spam filtering',
      ],
    },
    {
      type: 'heading',
      level: 2,
      text: 'When a number keeps calling',
    },
    {
      type: 'list',
      items: [
        'Block the number in your phone app',
        'Search it on WhoDatNumber and submit a report to help others',
        'Do not press buttons on robocalls — that confirms an active line',
      ],
    },
    {
      type: 'lookupCta',
    },
    {
      type: 'heading',
      level: 2,
      text: 'Protect your number',
    },
    {
      type: 'list',
      items: [
        'Avoid posting your mobile on public classifieds without need',
        'Use a secondary number for online sign-ups where possible',
        'Be cautious entering numbers on prize draws and unknown sites',
      ],
    },
    {
      type: 'link',
      to: '/learn/call-blocking-apps',
      label: 'Call blocking apps comparison',
    },
  ],
};

export default managingUnwantedCalls;

